import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class MeetingID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
